import { render, staticRenderFns } from "./FormCreateCessation.vue?vue&type=template&id=9e2f9562"
import script from "./FormCreateCessation.vue?vue&type=script&lang=ts"
export * from "./FormCreateCessation.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports